import './index.css'

type CheckboxNinegridProps = {
    name: string;
    checked: boolean;
    checkMark?: (value: any) => void;
}

export function Checkbox({ name, checked, checkMark }: CheckboxNinegridProps) {

    return (
        <label className={checked ? 'checkbox-ninegrid-checked' : 'checkbox-ninegrid'} htmlFor={name} onClick={checkMark} >
            {checked &&
                <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.76691 9.46756L1.21092 5.73602L0 6.99776L4.76691 12L15 1.26174L13.7976 0L4.76691 9.46756Z" fill="white"/>
                </svg>
            }

            <input type="checkbox" name={name} />
        </label>
    )
}